<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapState, mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Output",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Output ",
      items: [
        { text: "Home", href: "/" },
        { text: "Output", active: true },
      ],
      perPage: 50,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      sortDesc: false,
      modal_id: "",
      currentdate: moment(new Date()).format("YYYY-MM-DD"),

      // Control States
      currentTab: 0,
      isLoading: true, // Start as true so it shows loader on first hit

      // Expected Output filters
      expectedFilters: {
        product: "",
        date_from: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        date_to: moment(new Date()).format("YYYY-MM-DD"),
        page: 1,
        per_page: 50,
      },

      // Actual Output filters
      actualFilters: {
        product: "",
        confirmed_from: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        confirmed_to: moment(new Date()).format("YYYY-MM-DD"),
        created_from: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        created_to: moment(new Date()).format("YYYY-MM-DD"),
        page: 1,
        per_page: 50,
      },

      confirmdata: { product_type: "", product: "", id: "" },
      editdata: { product: "", id: "", quantity: "" },
      deletedata: { product: "", id: "" },
    };
  },
  computed: {
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("recipes", [
      "SaveStatus",
      "filterStatus",
      "ExpectedOutput",
      "ExpectedOutputPagination",
      "ActualOutput",
      "ActualOutputPagination",
    ]),
    ...mapGetters("auth", ["MyUserPerm"]),
    ...mapGetters("setting", ["GeneralSettings"]),
    ...mapGetters("production", ["ProducedProducts"]),

    rows() { return this.ExpectedOutputPagination ? this.ExpectedOutputPagination.total : 0; },
    rows2() { return this.ActualOutputPagination ? this.ActualOutputPagination.total : 0; },
  },
  watch: {
    show(newValue) {
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchExpectedOutput: "recipes/fetchExpectedOutput",
      FetchActualOutput: "recipes/fetchActualOutput",
      EditOutput: "recipes/editOutput",
      DeleteOutput: "recipes/deleteOutput",
      ConfirmOutput: "recipes/confirmOutput",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchItems: "production/fetchProducedProducts",
    }),

    async loadInitialData() {
      this.isLoading = true;
      await Promise.all([
        this.FetchExpectedOutput(this.expectedFilters),
        this.FetchActualOutput(this.actualFilters),
        this.FetchGeneralSettings(),
        this.FetchItems()
      ]);
      this.isLoading = false;
    },

    async applyExpectedFilters() {
      this.isLoading = true;
      this.expectedFilters.page = 1;
      await this.FetchExpectedOutput(this.expectedFilters);
      this.isLoading = false;
    },

    async applyActualFilters() {
      this.isLoading = true;
      this.actualFilters.page = 1;
      await this.FetchActualOutput(this.actualFilters);
      this.isLoading = false;
    },

    clearExpectedFilters() {
      this.expectedFilters = {
        product: "",
        date_from: "",
        date_to: "",
        page: 1,
        per_page: this.perPage,
      };
      this.applyExpectedFilters();
    },

    clearActualFilters() {
      this.actualFilters = {
        product: "",
        confirmed_from: "",
        confirmed_to: "",
        created_from: "",
        created_to: "",
        page: 1,
        per_page: this.perPage,
      };
      this.applyActualFilters();
    },

    onExpectedPageChange(page) {
      this.expectedFilters.page = page;
      this.FetchExpectedOutput(this.expectedFilters);
    },

    onActualPageChange(page) {
      this.actualFilters.page = page;
      this.FetchActualOutput(this.actualFilters);
    },

    onExpectedPerPageChange() {
      this.expectedFilters.page = 1;
      this.expectedFilters.per_page = this.perPage;
      this.FetchExpectedOutput(this.expectedFilters);
    },

    onActualPerPageChange() {
      this.actualFilters.page = 1;
      this.actualFilters.per_page = this.perPage;
      this.FetchActualOutput(this.actualFilters);
    },

    closeModal(modalId) {
      this.$nextTick(() => { this.$bvModal.hide(modalId); });
    },
    resetDeleteItem() { this.deletedata = { product: "", id: "" }; },
    resetEdit() { this.editdata = { product: "", id: "", quantity: "" }; },
    resetConfirm() { this.confirmdata = { product: "", id: "", product_type: "" }; },

    showEditModal(data) { this.editdata = { product: data.product, id: data.id, quantity: data.quantity }; },
    showDeleteModal(data) { this.deletedata = { product: data.product, id: data.id }; },
    showConfirmModal(data) { this.confirmdata = { product: data.product, id: data.id, product_type: "" }; },

    editOutput(modalId) {
      this.modal_id = modalId;
      this.EditOutput({ ...this.editdata, filters: this.expectedFilters });
    },
    deleteOutput(modalId) {
      this.modal_id = modalId;
      this.DeleteOutput({ ...this.deletedata, filters: this.expectedFilters });
    },
    confirmOutput(modalId) {
      this.modal_id = modalId;
      this.ConfirmOutput({
        ...this.confirmdata,
        expectedFilters: this.expectedFilters,
        actualFilters: this.actualFilters,
      });
    },
    Viewdetails(id) {
      if (id) {
        this.$router.push(`/comsumable_usage_details/${btoa(id)}`);
      }
    },
  },
  created() {
    this.loadInitialData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-tabs content-class="p-3 text-muted" v-model="currentTab">

              <!-- TAB 1: EXPECTED OUTPUT -->
              <b-tab class="border-0">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none"><i class="fas fa-home"></i></span>
                  <span class="d-none d-sm-inline-block">Expected Output</span>
                </template>

                <div class="row mb-3">
                  <div class="col-12">
                    <div class="card border shadow-none">
                      <div class="card-body">
                        <div class="row align-items-end">
                          <div class="col-md-3 mb-2 form-group">
                            <label class="form-label">Filter by Product</label>
                            <model-list-select
                              :list="ProducedProducts ? [{ id: '', name: 'All Products' }, ...ProducedProducts] : []"
                              v-model="expectedFilters.product" option-value="id" option-text="name"
                              placeholder="Select Product" @input="applyExpectedFilters()"></model-list-select>
                          </div>
                          <div class="col-md-4 mb-2 form-group">
                            <label class="form-label">Filter by date of adding:</label>
                            <div class="row g-2">
                              <div class="col-6">
                                <label class="small text-muted">From</label>
                                <input type="date" v-model="expectedFilters.date_from" class="form-control" />
                              </div>
                              <div class="col-6">
                                <label class="small text-muted">To</label>
                                <input type="date" v-model="expectedFilters.date_to" class="form-control" />
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4 mb-2">
                            <button @click="applyExpectedFilters" class="btn btn-primary"
                              :disabled="isLoading || filterStatus">
                              <b-spinner v-if="isLoading || filterStatus" small class="me-1"></b-spinner>
                              <i v-else class="fa fa-filter"></i> Filter
                            </button>
                            <button @click="clearExpectedFilters" class="btn btn-secondary ms-2"
                              :disabled="isLoading || filterStatus">
                              <i class="fa fa-times"></i> Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-md-4">
                    <label class="d-inline-flex align-items-center mb-0">
                      Show&nbsp;
                      <b-form-select class="form-select form-select-sm" v-model="perPage"
                        @change="onExpectedPerPageChange" :options="pageOptions" size="sm"></b-form-select>
                      &nbsp;entries
                    </label>
                  </div>
                </div>

                <div class="table-responsive mb-0 mt-3">
                  <table class="table table-centered table-nowrap table-hover datatables">
                    <thead class="thead-light">
                      <tr>
                        <th>S/N</th>
                        <th>PRODUCT</th>
                        <th>QUANTITY</th>
                        <th>ADDED BY</th>
                        <th>ADDED ON</th>
                        <th>CONFIRMED ON</th>
                        <th>ACTIONS</th>
                      </tr>
                    </thead>
                    <tbody v-if="isLoading || filterStatus">
                      <tr>
                        <td colspan="7" class="text-center p-5">
                          <b-spinner variant="warning"></b-spinner>
                          <p class="mt-2">Fetching expected output...</p>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else-if="ExpectedOutput && ExpectedOutput.length > 0">
                      <tr v-for="(item, index) in ExpectedOutput" :key="'exp-' + item.id">
                        <td>{{ (ExpectedOutputPagination.current_page - 1) * ExpectedOutputPagination.per_page + index +
                          1 }}</td>
                        <td>{{ item.product }}</td>
                        <td>{{ item.quantity }} {{ item.unit }}</td>
                        <td>{{ item.user }}</td>
                        <td>{{ item.date }}</td>
                        <td>{{ item.confirmed_on }}</td>
                        <td>
                          <b-button-group>
                            <b-button class="btn btn-primary" size="sm" @click="Viewdetails(item.consumable_usage_id)">Details</b-button>
                            <b-button v-if="MyUserPerm.edit_expected_output && item.status == 0" size="sm"
                              variant="primary" v-b-modal.edit-item-modal @click="showEditModal(item)"><i
                                class="fa fa-edit"></i></b-button>
                            <b-button v-if="MyUserPerm.delete_expected_output && item.status == 0"
                              v-b-modal.delete-item-modal variant="danger" size="sm" @click="showDeleteModal(item)"><i
                                class="fa fa-trash"></i></b-button>
                            <b-button v-if="MyUserPerm.confirm_expected_output && item.status == 0"
                              v-b-modal.confirm-modal variant="success" size="sm" @click="showConfirmModal(item)"><i
                                class="fa fa-check"></i> Confirm</b-button>
                            <span v-if="item.status == 1" class="badge bg-soft-info text-info p-2">Confirmed</span>
                          </b-button-group>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="7" class="text-center p-5">No records found. Adjust your filters.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Pagination -->
                <div class="row mt-3" v-if="rows > 0">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-end">
                      <ul class="pagination pagination-rounded mb-0">
                        <b-pagination v-model="expectedFilters.page" :total-rows="rows"
                          :per-page="expectedFilters.per_page" @change="onExpectedPageChange"></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </b-tab>

              <!-- TAB 2: ACTUAL OUTPUT -->
              <b-tab class="border-0">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none"><i class="fas fa-check-circle"></i></span>
                  <span class="d-none d-sm-inline-block">Actual Output</span>
                </template>

                <div class="row mb-3">
                  <div class="col-12">
                    <div class="card border shadow-none">
                      <div class="card-body">
                        <div class="row align-items-end">
                          <div class="col-md-3 mb-3">
                            <label class="form-label">Filter by Product</label>
                            <model-list-select :list="ProducedProducts || []" v-model="actualFilters.product"
                              option-value="id" option-text="name" @input="applyActualFilters()"></model-list-select>
                          </div>
                          <div class="col-md-6 mb-3">
                            <label class="form-label">Filter by date of confirmation:</label>
                            <div class="row g-2">
                              <div class="col-6"><label class="small text-muted">From</label><input type="date"
                                  v-model="actualFilters.confirmed_from" class="form-control" /></div>
                              <div class="col-6"><label class="small text-muted">To</label><input type="date"
                                  v-model="actualFilters.confirmed_to" class="form-control" /></div>
                            </div>
                          </div>
                          <div class="col-md-3 mb-3">
                            <button @click="applyActualFilters" class="btn btn-primary"
                              :disabled="isLoading || filterStatus">
                              <b-spinner v-if="isLoading || filterStatus" small class="me-1"></b-spinner>
                              <i v-else class="fa fa-filter"></i> Filter
                            </button>
                            <button @click="clearActualFilters" class="btn btn-secondary ms-2"
                              :disabled="isLoading || filterStatus">
                              <i class="fa fa-times"></i> Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-md-4">
                    <label class="d-inline-flex align-items-center mb-0">
                      Show&nbsp;
                      <b-form-select class="form-select form-select-sm" v-model="perPage"
                        @change="onActualPerPageChange" :options="pageOptions" size="sm"></b-form-select>
                      &nbsp;entries
                    </label>
                  </div>
                </div>

                <div class="table-responsive mb-0 mt-3">
                  <table class="table table-centered table-nowrap table-hover datatables">
                    <thead class="thead-light">
                      <tr>
                        <th>S/N</th>
                        <th>PRODUCT</th>
                        <th>EXPECTED QTY</th>
                        <th>CONFIRMED QTY</th>
                        <th>LOST QTY</th>
                        <th>LOSS %GE</th>
                        <th>ADDED BY</th>
                        <th>CONFIRMED ON</th>
                        <th>ACTIONS</th>
                      </tr>
                    </thead>
                    <tbody v-if="isLoading || filterStatus">
                      <tr>
                        <td colspan="7" class="text-center p-5"><b-spinner variant="warning"></b-spinner></td>
                      </tr>
                    </tbody>
                    <tbody v-else-if="ActualOutput && ActualOutput.length > 0">
                      <tr v-for="(item, index) in ActualOutput" :key="'act-' + item.id">
                        <td>{{ (ActualOutputPagination.current_page - 1) * ActualOutputPagination.per_page + index + 1
                          }}</td>
                        <td>{{ item.product }}</td>
                        <td>{{ item.expected_quantity }} {{ item.unit }}</td>
                        <td>{{ item.quantity }} {{ item.unit }}</td>
                        <td>{{ item.lost_quantity }} {{ item.unit }}</td>
                        <td>{{ item.loss_percent }}</td>
                        <td>{{ item.user }}</td>
                        <td>{{ item.date }}</td>
                        <b-button class="btn btn-primary" size="sm" @click="Viewdetails(item.consumable_usage_id)">Details</b-button>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="7" class="text-center p-5">No actual output records found.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Pagination -->
                <div class="row mt-3" v-if="rows2 > 0">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-end">
                      <ul class="pagination pagination-rounded mb-0">
                        <b-pagination v-model="actualFilters.page" :total-rows="rows2"
                          :per-page="actualFilters.per_page" @change="onActualPageChange"></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

    <!-- Modals Restored with Spinners -->
    <b-modal id="confirm-modal" hide-footer @hidden="resetConfirm()" header-bg-variant="warning"
      header-text-variant="light">
      <template #modal-title>Confirm output for <small><em>{{ confirmdata.product }}</em></small></template>
      <div class="p-3">
        <h5>Confirm output for <em class="text-warning">{{ confirmdata.product }}</em>?</h5>
        <div v-if="GeneralSettings.multiple_stores == 1" class="mt-3">
          <label>Product Type</label>
          <select v-model="confirmdata.product_type" class="form-control">
            <option value="">Finished Product</option>
            <option value="1">Semi-finished Product</option>
          </select>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" @click="closeModal('confirm-modal')">Close</button>
        <button class="btn btn-primary" @click="confirmOutput('confirm-modal')" :disabled="SaveStatus">
          <b-spinner v-if="SaveStatus" small class="me-1"></b-spinner> Proceed
        </button>
      </div>
    </b-modal>

    <b-modal id="edit-item-modal" hide-footer @hidden="resetEdit()" :title="'Edit ' + editdata.product">
      <div class="form-group mb-3"><label>Quantity</label><input type="number" class="form-control"
          v-model="editdata.quantity" /></div>
      <div class="modal-footer">
        <button class="btn btn-danger" @click="closeModal('edit-item-modal')">Close</button>
        <button class="btn btn-primary" @click="editOutput('edit-item-modal')" :disabled="SaveStatus">
          <b-spinner v-if="SaveStatus" small class="me-1"></b-spinner> Save Changes
        </button>
      </div>
    </b-modal>

    <b-modal id="delete-item-modal" hide-footer @hidden="resetDeleteItem" title="Delete Output">
      <div class="p-3">
        <h5>Delete record for {{ deletedata.product }}?</h5>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" @click="closeModal('delete-item-modal')">No</button>
        <button class="btn btn-danger" @click="deleteOutput('delete-item-modal')" :disabled="SaveStatus">
          <b-spinner v-if="SaveStatus" small class="me-1"></b-spinner> Yes, Delete
        </button>
      </div>
    </b-modal>
  </Layout>
</template>

<style>
.btn-primary,
.page-link,
.pagination .active .page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
  color: white !important;
}

.bg-soft-info {
  background-color: rgba(80, 165, 241, 0.15);
}

.bg-soft-success {
  background-color: rgba(52, 195, 143, 0.15);
}
</style>